import { useStableOptions } from '@/hooks/useStable';
import { StandaloneComponentProps } from '@/types/component';
import { UseTheme } from 'lib/contexts/ComponentClassNameFactory';
import { standaloneComponent } from 'modules/dynamic-components';
import { FunctionComponent } from 'react';

export type GenericStandaloneComponentProps = {
  as: string;
  theme: {
    key?: string;
    useTheme?: UseTheme<any>;
  };
};

export const GenericStandaloneComponent = <T extends StandaloneComponentProps>({
  as,
  theme: { key, useTheme } = {},
}: GenericStandaloneComponentProps) => {
  const Component = standaloneComponent<T>(as);

  const GenericStandaloneComponent: FunctionComponent<T> = ({ options, ...props }) => {
    const theme = useTheme?.(key);
    const stableOptions = useStableOptions({ theme }, options);

    return <Component options={stableOptions} {...(props as T)} />;
  };

  Object.defineProperty(GenericStandaloneComponent, 'displayName', {
    value: Component.name || Component.displayName || 'GenericStandaloneComponent',
    writable: true,
  });

  return GenericStandaloneComponent;
};
